import { IssuesCloseOutlined } from '@ant-design/icons';

const IssuesIcon = ({ height = '14px', width = height, altText = 'icon', selected }) => {
  return <IssuesCloseOutlined style={{ fontSize: height }} />;
};

export default IssuesIcon;
